export const planHistoryFooter_style = {
  rootSx: {},
};
